export const authApiRoutes = {
  login: "/auth/login",
  signUp: "/auth/signup",
  refreshToken: "/auth/refresh-token",
  verifyOtp: "/auth/verify-otp",
  forgotPassword: "/auth/forgot-password",
  resetPassword: "/auth/reset-password",
  sendOtp: "/auth/send-otp",
  // google: "/auth/login/google"
};

export const squadApiRoutes = {
  getAllSquads: "/ajosquad/squad",
  getSquad: (id: string) => `/ajosquad/squad/${id}`,
  createSquad: "/ajosquad/squad",
  createCustomSquad: "/ajosquad/squad/custom",
  joinSquad: (id: string) => `/ajosquad/squad/${id}/join`,
  joinTestSquad: (id: string) => `/ajosquad/squad/${id}/joinTestSquad`,
  addNewSquadPosition: (id: string) => `/ajosquad/squad/${id}/update-position`,
  updateSquadMemberPosition: (squadId: string, squadMemberId: string) =>
    `/ajosquad/squad/${squadId}/update-position/${squadMemberId}`,
  updateSquadMemberGuarantor: (squadId: string) =>
    `/ajosquad/squad/${squadId}/update-guarantor`,
  connectBank: "/ajosquad/payments/connect-bank",
  getSquadStats: "/ajosquad/squad/stats",
  getSquadStatsByStatus: (status: string) =>
    `/ajosquad/squad/stats/status?status=${status}`,
  getSquadMembers: "/ajosquad/squad/squadmembers",
  getUserSquad: (id: string) => `/ajosquad/squad/user/${id}`,
  getUserSquads: "/ajosquad/squads/me",
  removeSquaMember: (squadId: string, squadMemberId: string) =>
    `/ajosquad/squad/${squadId}/remove-member/${squadMemberId}`,
};

export const userApiRoutes = {
  user: {
    getMe: "/user/me",
    getUserById: (userId: string) => `/user/${userId}`,
    getAllUsers: "/user",
    exportUsers: "/admin/users/export",
    updateUserPersonal: (userId: string) => `/user/${userId}/personal-info`,
    updateUserEmployer: (userId: string) => `/user/${userId}/employer-info`,
    changePassword: (userId: string) => `/user/${userId}/update-password`,
    countAll: "/user/countAll",
    getInvestments: "/ajohome/user/stats/investment",
    getPodInvestments: "/ajohome/user/stats/pod",
    checkUserPodStatus: (id: string) => `/ajohome/user/pods/${id}/has-join`,

    deleteUser: (userId: string) => `/admin/delete-user/${userId}`,
    setEquifaxConsent: "/user/equifax-consent",
  },
  kyc: {
    getKYC: (userId: string) => `/user/${userId}/kyc`,
    createKYC: (userId: string) => `/user/${userId}/kyc`,
    updateKYC: (userId: string) => `/user/${userId}/kyc`,
  },
  payoutInfo: {
    get: (userId: string) => `/user/${userId}/payout-info`,
    submit: (userId: string) => `/user/${userId}/payout-info`,
    adminList: "/admin/payout-info",
    adminExport: "/admin/payout-info/export",
  },
  bank: {
    getAllBanks: "/ajosquad/bank",
    getBank: (bankId: string) => `/ajosquad/bank/${bankId}`,
    createBank: "/ajosquad/bank",
    updateBank: (bankId: string) => `/ajosquad/bank/${bankId}`,
    deleteBank: (bankId: string) => `/ajosquad/bank/${bankId}`,
  },
  guarantor: {
    getAllGuarantors: (userId: string) => `/guarantor/query?id=${userId}`,
    getGuarantor: (guarantorId: string) => `/guarantor/${guarantorId}`,
    addGuarantor: "/guarantor",
    updateGuarantor: (guarantorId: string) => `/guarantor/${guarantorId}`,
    deleteGuarantor: (guarantorId: string) => `/guarantor/${guarantorId}`,
  },
  investmentAssessment: {
    getAssessment: (podType: string) => `/ajohome/questionnaires/${podType}`,
    submitAssessment: "/ajohome/questionnaires/responses",
    getUsersResponses: (userId: string) =>
      `ajohome/questionnaires/responses/user/${userId}`,
  },
};

export const guarantorApiRoutes = {
  getAllGuarantors: "/guarantor/query",
  getGuarantorStats: "/guarantor/stats",
  getGuarantor: (guarantorId: string) => `/guarantor/${guarantorId}`,
  addGuarantor: "/guarantor",
  updateGuarantor: (guarantorId: string) => `/guarantor/${guarantorId}`,
};

export const statisticsApiRoutes = {
  getUserStatDashboard: "/statistics/dashboard/transaction",
};

export const contractAgreementApiRoutes = {
  admin: {
    getAllContractAgreements: "/admin/contract-agreement",
    getContractAgreement: (contractId: string) =>
      `/admin/contract-agreement/${contractId}`,
    createAgreement: "/admin/contract-agreement",
  },
  user: {
    getAllContractAgreements: "/user/contract-agreement",
    getContractAgreement: (contractId: string) =>
      `/user/contract-agreement/${contractId}`,
    agreeOrRejectContract: (contractId: string) =>
      `/user/contract-agreement/${contractId}`,
  },
};
export const podApiRoutes = {
  getAllPodCategories: "/ajohome/categories",
  createPod: "/ajohome/pods",
  editPod: (id: string) => `/ajohome/pods/${id}`,
  getPodStats: "/ajohome/pods/stats/overview",
  getAllTransactions: "/ajohome/pods/transactions/all",
  getAllPodByStatus: "/ajohome/pods",
  getPodStatsByStatus: (status: string) => `/ajohome/pods/stats/${status}`,
  getPodPositions: (id: string) => `/ajohome/pods/${id}/positions/available`,
  getPodById: (id: string) => `/ajohome/pods/${id}`,
  getMembersById: (id: string) => `/ajohome/pods/${id}/members`,
  activePodTransactions: (id: string) => `/ajohome/pods/${id}/transactions`,
  getPodMembersStats: "/ajohome/pods/members/stats",
  getAllMembers: "/ajohome/pods/members",
  getMemberInfo: (id: string) => `/ajohome/pods/members/${id}/details`,
  getMemberPodInfo: (id: string) => `/ajohome/pods/members/${id}/pods`,
  changeMembersPosition: (payload: any) =>
    `/ajohome/pods/${payload.podId}/members/${payload.membersId}/position`,
  memberTransactions: (id: string) =>
    `/ajohome/pods/members/${id}/transactions`,
  deletePod: (id: string) => `/ajohome/pods/${id}`,
  startPod: (id: string) => `/ajohome/pods/${id}/start`,
  getAllPods: "/ajohome/pods",
  getUserPods: `/ajohome/user/pods`,
  removePodMember: (payload: any) =>
    `/ajohome/pods/${payload?.memberId}/members/${payload?.id}/remove`,
  connectBank: "/ajohome/user/pods/bank/connect",
  completeBankConnection: "/ajohome/user/pods/bank/complete",
  joinPod: (id: string) => `/ajohome/user/pods/${id}/join`,
  updatePodUnit: (payload: any) =>
    `/ajohome/pods/${payload?.podId}/members/${payload.memberId}/edit`,
};
export const galleryRoutes = {
  getAllGallery: "/ajohome/portfolios",
  getGallery: (galleryId: string) => `/ajohome/portfolios/${galleryId}`,
  uploadToClaudinary: "/image/uploads/multiple",
  usersPortfolio: "/ajohome/portfolios/user",
};
export const reportRoute = {
  uploadSingleReport: "/document/uploads/single",
  reportUpload: (id: string) => `/ajohome/portfolios/${id}/report/remove`,
  addReport: (id: string) => `/ajohome/portfolios/${id}/report/add`,
};
